import { render, staticRenderFns } from "./DetailsPageHeader.vue?vue&type=template&id=73a3a970"
import script from "./DetailsPageHeader.vue?vue&type=script&lang=js"
export * from "./DetailsPageHeader.vue?vue&type=script&lang=js"
import style0 from "./DetailsPageHeader.vue?vue&type=style&index=0&id=73a3a970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports